import { AddEmailDelegateActionSchema } from '../components/policies/policy-actions/add-email-delegate';
import { AddSendAsActionSchema } from '../components/policies/policy-actions/add-send-as';
import { AddSharedDriveActionSchema } from '../components/policies/policy-actions/add-share-drive';
import { AddToGroupActionSchema } from '../components/policies/policy-actions/add-to-group';
import { ApplySignatureTemplateActionSchema } from '../components/policies/policy-actions/apply-signature-template';
import { ChangeContactSharingActionSchema } from '../components/policies/policy-actions/change-contact-sharing';
import { ChangeCpanelRoleActionSchema } from '../components/policies/policy-actions/change-cPanel-role';
import { ChangeGpanelRoleActionSchema } from '../components/policies/policy-actions/change-gPanel-role';
import { ChangeImapActionSchema } from '../components/policies/policy-actions/change-imap';
import { ChangePopActionSchema } from '../components/policies/policy-actions/change-pop';
import { CreateGmailLabelActionSchema } from '../components/policies/policy-actions/create-gmail-label';
import { DuplicateUserGroupsActionSchema } from '../components/policies/policy-actions/duplicate-user-groups';
import { DynamicGroupAssignmentActionSchema } from '../components/policies/policy-actions/dynamic-group-assignment';
import { LastLoginActionSchema } from '../components/policies/policy-actions/last-login';
import { ReassignAliasesActionSchema } from '../components/policies/policy-actions/reassign-alliases';
import { RemoveDomainFindableSharesActionSchema } from '../components/policies/policy-actions/remove-domain-findable-shares';
import { RemoveEmailDelegateActionSchema } from '../components/policies/policy-actions/remove-email-delegate';
import { RemoveFromGroupActionSchema } from '../components/policies/policy-actions/remove-from-group';
import { RemoveSpecificSharesActionSchema } from '../components/policies/policy-actions/remove-specific-shares';
import { SetForwardingActionSchema } from '../components/policies/policy-actions/set-forwarding';
import { SetOrganizationActionSchema } from '../components/policies/policy-actions/set-organization';
import { SuspendInactiveUsersActionSchema } from '../components/policies/policy-actions/suspend-inactive-users';
import { SuspendUserActionSchema } from '../components/policies/policy-actions/suspend-user';
import { UpdateMobileDeviceActionSchema } from '../components/policies/policy-actions/update-mobile-devices';
import {
  ClearPrimaryCalendarSchema,
  DisableTwoFactorSchema,
  ForcePasswordResetSchema,
  HideFromDirectorySchema,
  RemovePublicSharesSchema,
  SignOutUserSchema,
  UnsuspendUserSchema,
} from '../components/policies/policy-schema';
import { SetProfileInfoActionSchema } from '../components/policies/set-profile-info-step';
import { CreateGmailFilterActionSchema } from '../components/policies/step-three';

export const policyActions = [
  {
    value: 'Add_Delegate_To_Account',
    label: 'Add Delegate To Account',
    policyTypes: ['standard', 'newUser'],
    groupType: 'Gmail Settings',
    description: `Creates a Gmail delegate for the user's Gmail.`,
    hasContent: true,
    schema: AddEmailDelegateActionSchema,
  },
  {
    value: 'Add_Send_As',
    label: 'Add Send As',
    policyTypes: ['standard', 'newUser'],
    groupType: 'Gmail Settings',
    description: `Please note that this will only work for Domain Aliases. This WILL
          NOT add a Send As alias for Secondary Domains.`,
    hasContent: true,
    schema: AddSendAsActionSchema,
  },
  {
    value: 'Add_To_Group',
    label: 'Add To Group',
    policyTypes: ['standard', 'newUser'],
    groupType: 'Groups',
    description: `Add user(s) to specified group(s) and assign group role.`,
    hasContent: true,
    schema: AddToGroupActionSchema,
  },
  {
    value: 'Add_To_Shared_Drive',
    label: 'Add To Shared Drive',
    policyTypes: ['standard', 'newUser'],
    groupType: 'Drive',
    description: `Add user(s) to specified Shared Drive(s) and assign Drive role.`,
    hasContent: true,
    schema: AddSharedDriveActionSchema,
  },
  {
    value: 'Apply_Signature_Template',
    label: 'Apply Signature Template',
    policyTypes: ['newUser'],
    groupType: 'Gmail Settings',
    description: `Apply a signature template to the new user's Gmail account.`,
    hasContent: true,
    schema: ApplySignatureTemplateActionSchema,
  },
  {
    value: 'Change_Contact_Sharing',
    label: 'Change Contact Sharing',
    policyTypes: ['standard', 'newUser'],
    groupType: 'User',
    description: `Enable contact sharing.`,
    hasContent: true,
    schema: ChangeContactSharingActionSchema,
  },
  {
    value: 'Change_cPanel_Role',
    label: 'Change cPanel Role',
    policyTypes: ['standard'],
    groupType: 'Roles',
    description: `Change user(s) cPanel role.`,
    hasContent: true,
    schema: ChangeCpanelRoleActionSchema,
  },
  {
    value: 'Change_gPanel_Role',
    label: 'Change gPanel Role',
    policyTypes: ['standard'],
    groupType: 'Roles',
    description: `Change user(s) gPanel role.`,
    hasContent: true,
    schema: ChangeGpanelRoleActionSchema,
  },
  {
    value: 'Change_IMAP',
    label: 'Change IMAP',
    policyTypes: ['standard', 'newUser'],
    groupType: 'Gmail Settings',
    description: `Enable Imap.`,
    hasContent: true,
    schema: ChangeImapActionSchema,
  },
  {
    value: 'Change_POP',
    label: 'Change POP',
    policyTypes: ['standard', 'newUser'],
    groupType: 'Gmail Settings',
    description: `Enable Pop for 'all mail' or 'only mail from now on' and select the action to be taken.`,
    hasContent: true,
    schema: ChangePopActionSchema,
  },
  {
    value: 'Clear_Primary_Calendar',
    label: 'Clear Primary Calendar',
    policyTypes: ['standard'],
    groupType: 'Calendar',
    description: `Clears all event from the user's primary calendar.`,
    hasContent: false,
    schema: ClearPrimaryCalendarSchema,
  },
  {
    value: 'Create_Gmail_Filter',
    label: 'Create Gmail Filter',
    policyTypes: ['standard', 'newUser'],
    groupType: 'Gmail Settings',
    description: `Criteria for gmail filter will be provided in the next step.`,
    hasContent: true,
    schema: CreateGmailFilterActionSchema,
  },
  {
    value: 'Create_Gmail_Label',
    label: 'Create Gmail Label',
    policyTypes: ['standard', 'newUser'],
    groupType: 'Gmail Settings',
    description: `Create gmail label(s).`,
    hasContent: true,
    schema: CreateGmailLabelActionSchema,
  },
  {
    value: 'Disable_Two_Factor',
    label: 'Disable Two Factor',
    policyTypes: ['standard', 'newUser'],
    groupType: 'User',
    description: `Disables Two Factor verification for the user.`,
    hasContent: false,
    schema: DisableTwoFactorSchema,
  },
  {
    value: 'Duplicate_User_Groups',
    label: 'Duplicate User Groups',
    policyTypes: ['standard', 'newUser'],
    groupType: 'Groups',
    description: `Duplicates the user(s) groups.`,
    hasContent: true,
    schema: DuplicateUserGroupsActionSchema,
  },
  {
    value: 'Force_Password_Reset',
    label: 'Force Password Reset',
    policyTypes: ['standard'],
    groupType: 'User',
    description: `Resets the user(s) password.`,
    hasContent: false,
    schema: ForcePasswordResetSchema,
  },
  {
    value: 'Hide_From_Directory',
    label: 'Hide From Directory',
    policyTypes: ['standard'],
    groupType: 'User',
    description: `Removes the user from the Global Address list.`,
    hasContent: false,
    schema: HideFromDirectorySchema,
  },
  {
    value: 'Last_Login_Action',
    label: 'Last Login Action',
    policyTypes: ['standard'],
    groupType: 'User',
    description: `Suspend or delete accounts not logged in after a set number of days.`,
    hasContent: true,
    schema: LastLoginActionSchema,
  },
  {
    value: 'Reassign_Aliases',
    label: 'Reassign Aliases',
    policyTypes: ['standard'],
    groupType: 'User',
    description: `Transfers all aliases from target users to the user chosen below.`,
    hasContent: true,
    schema: ReassignAliasesActionSchema,
  },
  {
    value: 'Remove_Delegate_From_Account',
    label: 'Remove Delegate From Account',
    policyTypes: ['standard'],
    groupType: 'Gmail Settings',
    description: `Remove Gmail delegates for the user's Gmail.`,
    hasContent: true,
    schema: RemoveEmailDelegateActionSchema,
  },
  {
    value: 'Remove_Domain_Findable_Shares',
    label: 'Remove Domain Findable Shares',
    policyTypes: ['standard'],
    groupType: 'Drive',
    description: `Remove domain findable shares with access type:`,
    hasContent: true,
    schema: RemoveDomainFindableSharesActionSchema,
  },
  {
    value: 'Remove_From_Group',
    label: 'Remove From Group',
    policyTypes: ['standard'],
    groupType: 'Groups',
    description: `Remove user(s) from specific group(s) with an option to remove from all groups.`,
    hasContent: true,
    schema: RemoveFromGroupActionSchema,
  },
  {
    value: 'Remove_Public_Shares',
    label: 'Remove Public Shares',
    policyTypes: ['standard'],
    groupType: 'Drive',
    description: `Remove user(s) public shares.`,
    hasContent: false,
    schema: RemovePublicSharesSchema,
  },
  {
    value: 'Remove_Specific_Shares',
    label: 'Remove Specific Shares',
    policyTypes: ['standard'],
    groupType: 'Drive',
    description: `Remove user(s) specific shares by providing share address(s).`,
    hasContent: true,
    schema: RemoveSpecificSharesActionSchema,
  },
  {
    value: 'Set_Forwarding',
    label: 'Set Forwarding',
    policyTypes: ['standard'],
    groupType: 'Gmail Settings',
    description: `Set forwarding user.`,
    hasContent: true,
    schema: SetForwardingActionSchema,
  },
  {
    value: 'Set_Organization',
    label: 'Set Organization',
    policyTypes: ['standard', 'newUser'],
    groupType: 'User',
    description: `Set organization.`,
    hasContent: true,
    schema: SetOrganizationActionSchema,
  },
  {
    value: 'Set_Profile_Information',
    label: 'Set Profile Information',
    policyTypes: ['standard', 'newUser'],
    groupType: 'User',
    description: `Set profile information of a user. This will only update provided fields, leaving the rest of the profile information unchanged.  For Organizations and Addresses, the provided values will be applied to all entries that match the provided type (e.g., if 'Work' is provided as the type for Organizations, all existing 'Work' organizations will be updated).`,
    hasContent: true,
    schema: SetProfileInfoActionSchema,
  },
  {
    value: 'Sign_Out_User',
    label: 'Sign Out User',
    policyTypes: ['standard'],
    groupType: 'User',
    description: `Signs out the user from all web and device sessions and resets their sign-in cookies.`,
    hasContent: false,
    schema: SignOutUserSchema,
  },
  {
    value: 'Suspend_User',
    label: 'Suspend User',
    policyTypes: ['standard'],
    groupType: 'User',
    description: `Suspends the user with option to reset user(s) decom status.`,
    hasContent: true,
    schema: SuspendUserActionSchema,
  },
  {
    value: 'Unsuspend_User',
    label: 'Unsuspend User',
    policyTypes: ['standard'],
    groupType: 'User',
    description: `Unsuspends the user.`,
    hasContent: false,
    schema: UnsuspendUserSchema,
  },
  {
    value: 'Update_Mobile_Devices',
    label: 'Update Mobile Devices',
    policyTypes: ['standard'],
    groupType: 'Devices',
    description: `Provide the number of days since this last sync occurred, once this number of days has elapsed, the following chosen operations will occur in the order they are listed.`,
    hasContent: true,
    schema: UpdateMobileDeviceActionSchema,
  },
  {
    value: 'Suspend_Inactive_Users',
    label: 'Suspend Inactive Users',
    policyTypes: ['standard'],
    groupType: 'User',
    description: `The number of days since the user(s) last logged in. Once the number
          of days has elapsed, the user(s) will be suspended.`,
    hasContent: true,
    schema: SuspendInactiveUsersActionSchema,
  },
  {
    value: 'Dynamic_Group_Assignment',
    label: 'Dynamic Group Assignment',
    policyTypes: ['standard', 'newUser'],
    groupType: 'Groups',
    description: `Automate group assignments by selecting a user profile field and mapping its values to the appropriate groups.`,
    hasContent: true,
    schema: DynamicGroupAssignmentActionSchema,
  },
];
